module.exports = __webpack_public_path__ + "static/media/caret-up.1107e0b4.svg";